/**
 * The article's big Gestura line.
 *
 * Two things are set in it — the headline at the top of the page and the
 * reading rail's heading at the bottom — and they are meant to be the same
 * size. Named once because they drifted apart twice when each carried its own
 * numbers.
 *
 * Sizes in rem at the 1920 artboard. The root font size is fluid, so a
 * narrower window renders both proportionally smaller, together.
 */
export const ARTICLE_DISPLAY_TYPE =
    'font-gestura leading-[1.05] font-normal text-[#323232] max-md:text-[2rem] max-md:tracking-[-0.03em] md:text-[4.5rem] md:tracking-[-0.032em]';

/**
 * The article's opening paragraph.
 *
 * The same setting the body's section titles carry — Neue Haas Display at its
 * lightest, 28px set solid. Deliberately its own constant rather than shared
 * with them: the two are meant to match today and may not tomorrow, and a
 * shared value would make changing one change both.
 *
 * `font-light` asks for 300; the kit serves Display at 400/500/600/700, so it
 * renders Roman — the lightest cut there is.
 *
 * The word spacing is opened up rather than the letter spacing: Display sets
 * its spaces tight at this size, and widening the letters instead would undo
 * the tracking that makes the line read as one.
 */
export const ARTICLE_INTRO_TYPE =
    'font-display font-light text-[#232323] [word-spacing:0.1em] max-md:text-[1.5rem] max-md:leading-[1.1] md:text-[1.75rem] md:leading-[1.75rem] md:tracking-normal';

/**
 * The headline as the title page sets it (Figma 2471:68895): Gestura at 56px,
 * set solid, centred over the page. Smaller than {@link ARTICLE_DISPLAY_TYPE}
 * on purpose — the design draws the title page a size under the reading
 * rail's heading — so the two are no longer the one setting.
 */
export const ARTICLE_HEADLINE_TYPE =
    'font-gestura font-normal text-[#1f1f21] max-md:text-[2rem] max-md:leading-[1.05] max-md:tracking-[-0.03em] md:text-[4.5rem] md:leading-[1.02] md:tracking-[-0.02em]';
